import { render, staticRenderFns } from "./AddIconSlider.vue?vue&type=template&id=33e5f2ad&scoped=true&"
import script from "./AddIconSlider.vue?vue&type=script&lang=js&"
export * from "./AddIconSlider.vue?vue&type=script&lang=js&"
import style0 from "./AddIconSlider.vue?vue&type=style&index=0&id=33e5f2ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e5f2ad",
  null
  
)

export default component.exports